'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');
const IconButton_IconButton = require('../IconButton/IconButton.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const carousel = "_carousel_bo3ja_1";
const scrollableContainer = "_scrollable-container_bo3ja_11";
const carouselStyles = "_carousel-styles_bo3ja_35";
const rightArrowSpace = "_right-arrow-space_bo3ja_56";
const arrowButton = "_arrow-button_bo3ja_68";
const leftArrow = "_left-arrow_bo3ja_83";
const rightArrow = "_right-arrow_bo3ja_56";
const leftGradient = "_left-gradient_bo3ja_89";
const rightGradient = "_right-gradient_bo3ja_104";
const styles = {
	carousel: carousel,
	scrollableContainer: scrollableContainer,
	carouselStyles: carouselStyles,
	rightArrowSpace: rightArrowSpace,
	arrowButton: arrowButton,
	leftArrow: leftArrow,
	rightArrow: rightArrow,
	leftGradient: leftGradient,
	rightGradient: rightGradient
};

const Carousel = ({ children, id, role, elementWidth = 300, gap = 20, arrowButtonColor = "tertiary", arrowButtonSize = "medium", pageBackgroundColor = "BackgroundWeaker", pageGutterWidth = 20, paddingBottom = 12, disableScrollButtons = false, onLeftArrowClick, onRightArrowClick, className }) => {
  var _a, _b;
  const scrollContainerRef = React.useRef(null);
  const [scrollPosition, setScrollPosition] = React.useState(0);
  const [canScrollRightInitial, setCanScrollRightInitial] = React.useState(false);
  const carouselRef = React.useCallback((node) => {
    if (node !== null) {
      setCanScrollRightInitial(node.scrollWidth > node.getBoundingClientRect().width);
    }
  }, []);
  const handleLeftArrowClick = () => {
    var _a2;
    (_a2 = scrollContainerRef.current) === null || _a2 === void 0 ? void 0 : _a2.scrollBy({
      left: scrollContainerRef.current ? -Math.round(scrollContainerRef.current.clientWidth * 0.75) : -elementWidth,
      behavior: "smooth"
    });
    onLeftArrowClick === null || onLeftArrowClick === void 0 ? void 0 : onLeftArrowClick();
  };
  const handleRightArrowClick = () => {
    var _a2;
    (_a2 = scrollContainerRef.current) === null || _a2 === void 0 ? void 0 : _a2.scrollBy({
      left: scrollContainerRef.current ? Math.round(scrollContainerRef.current.clientWidth * 0.75) : elementWidth,
      behavior: "smooth"
    });
    onRightArrowClick === null || onRightArrowClick === void 0 ? void 0 : onRightArrowClick();
  };
  const scrollHandler = () => {
    var _a2, _b2;
    setScrollPosition((_b2 = (_a2 = scrollContainerRef.current) === null || _a2 === void 0 ? void 0 : _a2.scrollLeft) !== null && _b2 !== void 0 ? _b2 : 0);
  };
  const canScrollLeft = scrollPosition > 0;
  const canScrollRight = scrollContainerRef.current ? scrollPosition + ((_a = scrollContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) < ((_b = scrollContainerRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth) : canScrollRightInitial;
  return React__default.default.createElement(
    "div",
    { className: clsx.clsx(className, styles.carousel), style: {
      "--page-background-color": designSystem.Colors[pageBackgroundColor],
      "--gutter-width": `${pageGutterWidth}px`,
      "--element-gap": `${gap}px`,
      "--padding-bottom": `${paddingBottom}px`
    }, id, role },
    canScrollLeft && React__default.default.createElement(
      React.Fragment,
      null,
      React__default.default.createElement("div", { className: styles.leftGradient }),
      React__default.default.createElement(
        "div",
        { className: clsx.clsx(styles.arrowButton, styles.leftArrow) },
        React__default.default.createElement(IconButton_IconButton.IconButton, { name: "arrowSmallLeft", variant: arrowButtonColor, size: arrowButtonSize, "aria-label": "Scroll right through carousel", isDisabled: disableScrollButtons, onPress: handleLeftArrowClick, style: { borderRadius: "50%" } })
      )
    ),
    canScrollRight && React__default.default.createElement(
      React.Fragment,
      null,
      React__default.default.createElement("div", { className: styles.rightGradient }),
      React__default.default.createElement(
        "div",
        { className: clsx.clsx(styles.arrowButton, styles.rightArrow) },
        React__default.default.createElement(IconButton_IconButton.IconButton, { name: "arrowSmallRight", variant: arrowButtonColor, size: arrowButtonSize, "aria-label": "Scroll left through carousel", isDisabled: disableScrollButtons, onPress: handleRightArrowClick, style: { borderRadius: "50%" } })
      )
    ),
    React__default.default.createElement(
      "div",
      { className: styles.scrollableContainer, ref: scrollContainerRef, onScroll: scrollHandler },
      React__default.default.createElement("div", { ref: carouselRef, className: clsx.clsx(styles.carouselStyles, canScrollRightInitial && styles.rightArrowSpace) }, children)
    )
  );
};

exports.Carousel = Carousel;
//# sourceMappingURL=Carousel.cjs.js.map
